import {
  ConstraintFragment,
  ConstraintDaysOfWeekFragment,
  ConstraintLocationInStateFragment,
  ConstraintRequiresActivationFragment,
  ConstraintRequiresVoucherAvailableForDiscountFragment,
  ConstraintRequiresVoucherFragment,
  ConstraintStoreLocationFragment,
  ConstraintTimeOfDayFragment,
} from '@occc/graphql';

export const isLocationInState = (
  constraint: ConstraintFragment,
): constraint is ConstraintLocationInStateFragment => {
  return constraint?.__typename === 'ConstraintLocationInState';
};

export const isRequiresActivation = (
  constraint: ConstraintFragment,
): constraint is ConstraintRequiresActivationFragment => {
  return constraint.__typename === 'ConstraintRequiresActivation';
};

export const isStoreLocation = (
  constraint: ConstraintFragment,
): constraint is ConstraintStoreLocationFragment => {
  return constraint.__typename === 'ConstraintStoreLocation';
};

export const isRequiresVoucher = (
  constraint: ConstraintFragment,
): constraint is ConstraintRequiresVoucherFragment => {
  return constraint.__typename === 'ConstraintRequiresVoucher';
};

export const isRequiresVoucherForDiscount = (
  constraint: ConstraintFragment,
): constraint is ConstraintRequiresVoucherAvailableForDiscountFragment => {
  return constraint.__typename === 'ConstraintRequiresVoucherAvailableForDiscount';
};

export const isTimeOfDayArray = (array: any): array is ConstraintTimeOfDayFragment[] => {
  if (!Array.isArray(array)) {
    return false;
  }

  return !array.find((item) => {
    return item.__typename !== 'ConstraintTimeOfDay';
  });
};

export const isDaysOfWeekArray = (array: any): array is ConstraintDaysOfWeekFragment[] => {
  if (!Array.isArray(array)) {
    return false;
  }

  return !array.find((item) => {
    return item.__typename !== 'ConstraintDaysOfWeek';
  });
};
